import { useCallback, useEffect, useState } from 'react';
import { trainingCentersAPI } from '../services/api';
import { mergeCenterOptions } from '../domain/batch/locationsFromBatches';

/**
 * Shared Location of Center catalog for pickers and the admin page.
 */
export default function useTrainingCenters({ includeInactive = false } = {}) {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await trainingCentersAPI.list(includeInactive ? { all: 1 } : undefined);
      const payload = res.data?.data ?? res.data;
      setCenters(Array.isArray(payload) ? payload : []);
    } catch (err) {
      setCenters([]);
      setError(err.response?.data?.message || err.message || 'Could not load locations');
    } finally {
      setLoading(false);
    }
  }, [includeInactive]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const options = mergeCenterOptions(centers.filter((row) => row.isActive !== false));

  return { centers, options, loading, error, refresh };
}

export function centerOptionsWithFallback(catalogOptions, batches = [], extra = []) {
  return mergeCenterOptions(catalogOptions, batches, extra);
}
